<template>
  <div class="IncrementalData-fieldWrap">
    <div class="IncrementalData-field">
      <p class="IncrementalData-supportingText">
        Take 60 seconds to tell us about yourself. And we’ll only send you jobs you want to apply for.
      </p>
      <div class="IncrementalData-question">
        <label
          for="name"
          class="IncrementalData-questionText"
        >
          What's your full name? *
        </label>
        <div class="IncrementalData-questionField">
          <form-input
            v-model.trim="fields.fullname"
            :error="validateStatus({ field: v$.fields.fullname, serverKey: 'fullname', label: 'Full name' })"
            :manual-validate="validateAll"
            placeholder="Enter your full name"
            input-type="text"
            data-rmpdev-selector="fullname"
            @change="validateBlur({ field: v$.fields.fullname, serverKey: 'fullname' })"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import incrementalMixin from '../mixins/incremental-data-field-mixin';

export default {
  mixins: [incrementalMixin],

  data() {
    return {
      v$: useVuelidate(),
      fields: {
        fullname: null,
      },
      fieldName: 'fullname',
    };
  },

  computed: {
    updatePayload() {
      return this.fields;
    },
  },
};
</script>
